import { HTTPClient } from '@abaco/web-common/src/HTTP';
import { CertificateCodesDictionary, CertificateFilter, CertigrafCampaignType, CertigrafCertificateInfo, CertigrafChecks, CertigrafIntermediarySendData, CertigrafOrganizationsDictionary, CertigrafPlot, CertigrafPlotData, CertigrafPrecertificateCreationData, CertigrafPrecertificateData, Council, PcertDeclaration, PcertEnsureProduct, PcertGuarantee, PcertHeader, PcertOutcome, PcertWarranty, PhytoFund, Product, ProductVarietyType, SignUserData, StartSignResponse } from '../models/CertigrafModel';

export default class CertigrafApi {
    private http: HTTPClient;

    constructor(http: HTTPClient) {
        this.http = http;
    }

    public getHttp(): HTTPClient
    {
        return this.http;
    }

    public async getCertificateCodes(): Promise<CertificateCodesDictionary | null> {
        return (await this.http.get("/pcert-api/api/v1/code/codes")).data;
    }

    public async getCertificateCodesById(subjectId: number, pcertId: number) {
        // BBBBBBBBBBBBBBBBB
        return (await this.http.get("/pcert-api/api/v1/farm/" + subjectId + "/pcert/" + pcertId + "/eventTypes")).data;
    }

    public async getPhytoFund(condifesaId: string): Promise<PhytoFund[]>
    {
        return (await this.http.get("/pcert-api/api/v1/code/phytoFund?condifesa_org=" + condifesaId)).data
    }

    public async getAvailableOrganizations(): Promise<CertigrafOrganizationsDictionary | null> {
        return (await this.http.get("/pcert-api/api/v1/org/orgs")).data;
    }

    public async getAvailableCampaignTypes(pcertType?: string): Promise<CertigrafCampaignType[] | null> {
        if(pcertType !== undefined)
            return (await this.http.get("/pcert-api/api/v1/code/campaignTypes?pcert_type=" + pcertType)).data;
        return (await this.http.get("/pcert-api/api/v1/code/campaignTypes")).data;
    }

    public async getCertificateList(subjectId: number, campaign: number, filter: CertificateFilter): Promise<CertigrafCertificateInfo[]> {
        let filterValues = '';

        if(filter.campaign_type !== undefined)
            filterValues += '&campaign_type=' + filter.campaign_type
        if(filter.council_descr !== undefined)
            filterValues += '&council_descr=' + filter.council_descr
        if(filter.min_dt_insert !== undefined && filter.min_dt_insert !== null)
            filterValues += '&min_dt_insert=' + new Date(filter.min_dt_insert.getTime() + (1000 * 60 * 60 * 24)).toISOString();
        if(filter.max_dt_insert !== undefined && filter.max_dt_insert !== null)
            filterValues += '&max_dt_insert=' + new Date(filter.max_dt_insert.getTime() + (1000 * 60 * 60 * 24)).toISOString();
        if(filter.pcert_type !== undefined)
            filterValues += '&pcert_type=' + filter.pcert_type
        if(filter.product_descr !== undefined)
            filterValues += '&product_descr=' + filter.product_descr
        if(filter.status !== undefined)
            filterValues += '&status=' + filter.status
        if(filter.pcert_id !== undefined)
            filterValues += '&pcert_id=' + filter.pcert_id

        return (await this.http.get("/pcert-api/api/v1/farm/" + subjectId + "/pcert?campaign=" + campaign + filterValues)).data
    }

    public async getIntermediaryCertificateList(campaign: number, filter: CertificateFilter): Promise<CertigrafCertificateInfo[]> {
        let filterValues = '';

        if(filter.campaign_type !== undefined)
            filterValues += '&campaign_type=' + filter.campaign_type
        if(filter.council_descr !== undefined)
            filterValues += '&council_descr=' + filter.council_descr
        if(filter.min_dt_insert !== undefined && filter.min_dt_insert !== null)
            filterValues += '&min_dt_insert=' + new Date(filter.min_dt_insert.getTime() + (1000 * 60 * 60 * 24)).toISOString();
        if(filter.max_dt_insert !== undefined && filter.max_dt_insert !== null)
            filterValues += '&max_dt_insert=' + new Date(filter.max_dt_insert.getTime() + (1000 * 60 * 60 * 24)).toISOString();
        if(filter.pcert_type !== undefined)
            filterValues += '&pcert_type=' + filter.pcert_type
        if(filter.product_descr !== undefined)
            filterValues += '&product_descr=' + filter.product_descr
        if(filter.status !== undefined)
            filterValues += '&status=' + filter.status
        if(filter.cuaa !== undefined)
            filterValues += '&farmer_descr=' + filter.cuaa
        if(filter.pcert_id !== undefined)
            filterValues += '&pcert_id=' + filter.pcert_id

        return (await this.http.get("/pcert-api/api/v1/intermediary/pcert/list?campaign=" + campaign + filterValues)).data
    }

    public async getCondifesaCertificateList(campaign: number, filter: CertificateFilter): Promise<CertigrafCertificateInfo[]> {
        let filterValues = '';

        if(filter.campaign_type !== undefined)
            filterValues += '&campaign_type=' + filter.campaign_type
        if(filter.council_descr !== undefined)
            filterValues += '&council_descr=' + filter.council_descr
        if(filter.min_dt_insert !== undefined && filter.min_dt_insert !== null)
            filterValues += '&min_dt_insert=' + new Date(filter.min_dt_insert.getTime() + (1000 * 60 * 60 * 24)).toISOString();
        if(filter.max_dt_insert !== undefined && filter.max_dt_insert !== null)
            filterValues += '&max_dt_insert=' + new Date(filter.max_dt_insert.getTime() + (1000 * 60 * 60 * 24)).toISOString();
        if(filter.pcert_type !== undefined)
            filterValues += '&pcert_type=' + filter.pcert_type
        if(filter.product_descr !== undefined)
            filterValues += '&product_descr=' + filter.product_descr
        if(filter.status !== undefined)
            filterValues += '&status=' + filter.status
        if(filter.cuaa !== undefined)
            filterValues += '&farmer_descr=' + filter.cuaa
        if(filter.pcert_id !== undefined)
            filterValues += '&pcert_id=' + filter.pcert_id

        return (await this.http.get("/pcert-api/api/v1/condifesa/pcert/list?campaign=" + campaign + filterValues)).data
    }

    public async getCertificateData(subjectId: number, pcertId: number): Promise<CertigrafPrecertificateData> {
        return (await this.http.get("/pcert-api/api/v1/farm/" + subjectId + "/pcert/" + pcertId)).data
    }

    public async getCouncils(subjectId: number, campaign: number): Promise<Council[]> {
        return (await this.http.get("/pcert-api/api/v1/farm/" + subjectId + "/plot/councils?campaign=" + campaign)).data;
    }

    public async getAvailableProducts(subjectId: number, pcertId: number, councilId: number): Promise<Product[]> {
        return (await this.http.get("/pcert-api/api/v1/farm/" + subjectId + "/pcert/" + pcertId + "/councils/" + councilId + "/products")).data
    }

    public async getAvailablePlots(subjectId: number, pcertId: number): Promise<CertigrafPlot[]> {
        return (await this.http.get("/pcert-api/api/v1/farm/" + subjectId + "/pcert/" + pcertId + "/plots")).data
    }
    public async getOtherPlots(subjectId: number, pcertId: number, campaignYear: number): Promise<CertigrafPlot[]> {
        return (await this.http.get("/pcert-api/api/v1/farm/" + subjectId + "/pcert/" + pcertId + "/other_plots?campaign=" + campaignYear)).data
    }
    public async getProductVarietyTypes(subjectId: number, pcertId: number): Promise<ProductVarietyType[]> {
        return (await this.http.get("/pcert-api/api/v1/farm/" + subjectId + "/pcert/" + pcertId + "/varietyTypes")).data
    }

    public async createNewPrecertificate(subjectId: number, certificateData: CertigrafPrecertificateCreationData): Promise<PcertHeader> {
        return (await this.http.post("/pcert-api/api/v1/farm/" + subjectId + "/pcert", certificateData)).data;
    }

    public async updateCertificateData(subjectId: number, pcertId: number, certificateData: PcertHeader): Promise<void> {
        await this.http.put("/pcert-api/api/v1/farm/" + subjectId + "/pcert/" + pcertId, certificateData);
    }

    public async addEnsuredProduct(subjectId: number, pcertId: number, ensuredProduct: PcertEnsureProduct): Promise<void> {
        await this.http.put("/pcert-api/api/v1/farm/" + subjectId + "/pcert/" + pcertId + "/ensure_product", ensuredProduct);
    }

    public async addEvent(subjectId: number, pcertId: number, eventCodes: string[]): Promise<void> {
        await this.http.post("/pcert-api/api/v1/farm/" + subjectId + "/pcert/" + pcertId + "/events", { "events": eventCodes });
    }

    public async addPhytopaties(subjectId: number, pcertId: number, phytopatyCodes: string[]): Promise<void> {
        await this.http.post("/pcert-api/api/v1/farm/" + subjectId + "/pcert/" + pcertId + "/phytopaties", { "phytopaties": phytopatyCodes });
    }

    public async addPlots(subjectId: number, pcertId: number, plotIds: number[]): Promise<void> {
        return (await this.http.post("/pcert-api/api/v1/farm/" + subjectId + "/pcert/" + pcertId + "/plots", { "plots": plotIds })).data;
    }

    public async addPlotData(subjectId: number, pcertId: number, plotData: CertigrafPlotData, plotId: number | null): Promise<CertigrafChecks | CertigrafPlot> {
        try {
            let res = null;
            if(plotId !== null)
                res = (await this.http.put("/pcert-api/api/v1/farm/" + subjectId + "/pcert/" + pcertId + "/plots/" + plotId, plotData)).data;
            else
                res = (await this.http.post("/pcert-api/api/v1/farm/" + subjectId + "/pcert/" + pcertId + "/plot", plotData)).data;
            return res;
        } catch(e) {
            if(e.response?.status === 400) {
                return e.response.data;
            }
            throw e;
        }
    }

    public async setAssurance(subjectId: number, pcertId: number, assuranceData: PcertWarranty): Promise<void> {
        await this.http.put("/pcert-api/api/v1/farm/" + subjectId + "/pcert/" + pcertId + "/warranty", assuranceData);
    }

    public async setDeclarations(subjectId: number, pcertId: number, declarationData: PcertDeclaration): Promise<void> {
        await this.http.put("/pcert-api/api/v1/farm/" + subjectId + "/pcert/" + pcertId + "/declaration", declarationData);
    }

    public async setIntermediary(subjectId: number, pcertId: number, intermediaryData: CertigrafIntermediarySendData): Promise<void> {
        await this.http.put("/pcert-api/api/v1/farm/" + subjectId + "/pcert/" + pcertId + "/intermediary", intermediaryData);
    }

    public async updatePrecertificate(subjectId: number, pcertId: number, certificateData: CertigrafPrecertificateCreationData): Promise<PcertHeader> {
        return (await this.http.put("/pcert-api/api/v1/farm/" + subjectId + "/pcert/" + pcertId, certificateData)).data;
    }

    public async firmPrecertificate(pcertId: number): Promise<CertigrafChecks | null> {
        try {
            await this.http.post("/pcert-api/api/v1/command/pcert/" + pcertId + "/firm");
            return null;
        } catch(e) {
            if(e.response?.status === 400) {
                return e.response.data;
            }
            throw e;
        }
    }

    public async sendPrecertificate(pcertId: number): Promise<CertigrafChecks | null> {
        try {
            await this.http.post("/pcert-api/api/v1/command/pcert/" + pcertId + "/send");
            return null;
        } catch(e) {
            if(e.response?.status === 400) {
                return e.response.data;
            }
            throw e;
        }
    }

    public async cancelPrecertificate(pcertId: number): Promise<CertigrafChecks | null> {
        try {
            await this.http.post("/pcert-api/api/v1/command/pcert/" + pcertId + "/cancel");
            return null;
        } catch(e) {
            if(e.response?.status === 400) {
                return e.response.data;
            }
            throw e;
        }
    }

    public async deletePrecertificate(subjectId: number, pcertId: number): Promise<CertigrafChecks | null> {
        try {
            await this.http.delete("/pcert-api/api/v1/farm/" + subjectId + "/pcert/" + pcertId);
            return null;
        } catch(e) {
            if(e.response?.status === 400) {
                return e.response.data;
            }
            throw e;
        }
    }

    public async duplicatePrecertificate(subjectId: number, pcertId: number, campaignYear: number): Promise<CertigrafChecks | null> {
        try {
            await this.http.post("/pcert-api/api/v1/farm/" + subjectId + "/pcert/" + pcertId + "/duplicate?campaign=" + campaignYear);
            return null;
        } catch(e) {
            if(e.response?.status === 400) {
                return e.response.data;
            }
            throw e;
        }
    }


    public async setIntermediaryAssurance(pcertId: number, assuranceData: PcertGuarantee): Promise<void> {
        await this.http.put("/pcert-api/api/v1/intermediary/pcert/" + pcertId + "/guarantee", assuranceData);
    }

    public async setIntermediaryOutcome(pcertId: number, outcomeData: PcertOutcome): Promise<void> {
        await this.http.put("/pcert-api/api/v1/intermediary/pcert/" + pcertId + "/outcome", outcomeData);
    }

    public async addIntermediaryEvent(pcertId: number, eventCodes: string[]): Promise<void> {
        await this.http.post("/pcert-api/api/v1/intermediary/pcert/" + pcertId + "/events", { "events": eventCodes });
    }

    public async addIntermediaryPhytopaties(pcertId: number, phytopatyCodes: string[]): Promise<void> {
        await this.http.post("/pcert-api/api/v1/intermediary/pcert/" + pcertId + "/phytopaties", { "phytopaties": phytopatyCodes });
    }

    public async rateCertificate(pcertId: number): Promise<void> {
        await this.http.post("/pcert-api/api/v1/command/pcert/" + pcertId + "/rate");
    }

    public async closeCertificateOk(pcertId: number): Promise<void> {
        await this.http.post("/pcert-api/api/v1/command/pcert/" + pcertId + "/closeOk");
    }

    public async closeCertificateKo(pcertId: number): Promise<void> {
        await this.http.post("/pcert-api/api/v1/command/pcert/" + pcertId + "/closeKo");
    }

    public async checkProduct(subjectId: number, pcertId: number, pcertHeader: PcertHeader): Promise<CertigrafChecks | null> {
        try {
            await this.http.post("/pcert-api/api/v1/farm/" + subjectId + "/pcert/" + pcertId + "/checks", pcertHeader);
            return null;
        } catch(e) {
            if(e.response?.status === 400) {
                return e.response.data;
            }
            throw e;
        }
    }

    public async checkPlot(subjectId: number, pcertId: number, plotPkid: number): Promise<CertigrafChecks | null> {
        try {
            await this.http.post("/pcert-api/api/v1/farm/" + subjectId + "/pcert/" + pcertId + "/plots/" + plotPkid + "/checks");
            return null;
        } catch(e) {
            if(e.response?.status === 400) {
                return e.response.data;
            }
            throw e;
        }
    }

    public async farmerReports(subjectId: number, campaign: number, filter: CertificateFilter): Promise<Blob>
    {
        let filterValues = '';

        if(filter.campaign_type !== undefined)
            filterValues += '&campaign_type=' + filter.campaign_type
        if(filter.council_descr !== undefined)
            filterValues += '&council_descr=' + filter.council_descr
        if(filter.min_dt_insert !== undefined && filter.min_dt_insert !== null)
            filterValues += '&min_dt_insert=' + new Date(filter.min_dt_insert.getTime() + (1000 * 60 * 60 * 24)).toISOString();
        if(filter.max_dt_insert !== undefined && filter.max_dt_insert !== null)
            filterValues += '&max_dt_insert=' + new Date(filter.max_dt_insert.getTime() + (1000 * 60 * 60 * 24)).toISOString();
        if(filter.pcert_type !== undefined)
            filterValues += '&pcert_type=' + filter.pcert_type
        if(filter.product_descr !== undefined)
            filterValues += '&product_descr=' + filter.product_descr
        if(filter.status !== undefined)
            filterValues += '&status=' + filter.status
        if(filter.pcert_id !== undefined)
            filterValues += '&pcert_id=' + filter.pcert_id

        return (await this.http.get("/pcert-api/api/v1/farm/" + subjectId + "/pcert/csv?campaign=" + campaign + filterValues, {responseType: 'blob'})).data
    }

    public async intermediaryReports(campaign: number, filter: CertificateFilter): Promise<Blob>
    {
        let filterValues = '';

        if(filter.campaign_type !== undefined)
            filterValues += '&campaign_type=' + filter.campaign_type
        if(filter.council_descr !== undefined)
            filterValues += '&council_descr=' + filter.council_descr
        if(filter.min_dt_insert !== undefined && filter.min_dt_insert !== null)
            filterValues += '&min_dt_insert=' + new Date(filter.min_dt_insert.getTime() + (1000 * 60 * 60 * 24)).toISOString();
        if(filter.max_dt_insert !== undefined && filter.max_dt_insert !== null)
            filterValues += '&max_dt_insert=' + new Date(filter.max_dt_insert.getTime() + (1000 * 60 * 60 * 24)).toISOString();
        if(filter.pcert_type !== undefined)
            filterValues += '&pcert_type=' + filter.pcert_type
        if(filter.product_descr !== undefined)
            filterValues += '&product_descr=' + filter.product_descr
        if(filter.status !== undefined)
            filterValues += '&status=' + filter.status
        if(filter.pcert_id !== undefined)
            filterValues += '&pcert_id=' + filter.pcert_id

        return (await this.http.get("/pcert-api/api/v1/intermediary/pcert/list/csv?campaign=" + campaign + filterValues, {responseType: 'blob'})).data
    }

    public async condifesaReports(campaign: number, filter: CertificateFilter): Promise<Blob>
    {
        let filterValues = '';

        if(filter.campaign_type !== undefined)
            filterValues += '&campaign_type=' + filter.campaign_type
        if(filter.council_descr !== undefined)
            filterValues += '&council_descr=' + filter.council_descr
        if(filter.min_dt_insert !== undefined && filter.min_dt_insert !== null)
            filterValues += '&min_dt_insert=' + new Date(filter.min_dt_insert.getTime() + (1000 * 60 * 60 * 24)).toISOString();
        if(filter.max_dt_insert !== undefined && filter.max_dt_insert !== null)
            filterValues += '&max_dt_insert=' + new Date(filter.max_dt_insert.getTime() + (1000 * 60 * 60 * 24)).toISOString();
        if(filter.pcert_type !== undefined)
            filterValues += '&pcert_type=' + filter.pcert_type
        if(filter.product_descr !== undefined)
            filterValues += '&product_descr=' + filter.product_descr
        if(filter.status !== undefined)
            filterValues += '&status=' + filter.status
        if(filter.pcert_id !== undefined)
            filterValues += '&pcert_id=' + filter.pcert_id

        return (await this.http.get("/pcert-api/api/v1/condifesa/pcert/list/csv?campaign=" + campaign + filterValues, {responseType: 'blob'})).data
    }

    public async totalPlotAreas(subjectId: number, pcertId: number)
    {
        return (await this.http.get("/pcert-api/api/v1/farm/" + subjectId + "/pcert/" + pcertId + "/plots/areaTot")).data
    }

    public async startSignProcedure(pcertId: number, userData: SignUserData, pdfFileName: string, pdfBase64: string, signBoundary: [number, number, number, number], page: number): Promise<StartSignResponse | CertigrafChecks>
    {
        try {
            const response = (await this.http.post("/pcert-api/api/v1/command/pcert/" + pcertId + "/firm/start", {
                first_name: userData.name,
                last_name: userData.surname,
                email: userData.email,
                phone: userData.telephone,
                file_name: pdfFileName,
                page: page,
                position: signBoundary,
                file_content: pdfBase64
            })).data;
            return response;
        } catch(e) {
            if(e.response?.status === 400) {
                return e.response.data;
            }
            throw e;
        }
    }

    public async startIntermediarySignProcedure(pcertId: number, userData: SignUserData, pdfFileName: string, pdfBase64: string, signBoundary: [number, number, number, number], page: number): Promise<StartSignResponse>
    {
        return (await this.http.post("/pcert-api/api/v1/command/pcert/" + pcertId + "/firm/start/intermediary", {
            first_name: userData.name,
            last_name: userData.surname,
            email: userData.email,
            phone: userData.telephone,
            file_name: pdfFileName,
            page: page,
            position: signBoundary,
            file_content: pdfBase64
        })).data
    }

    public async getXLSPrint(subjectId: number, pcertId: number): Promise<Blob>
    {
        return (await this.http.get("/pcert-api/api/v1/farm/" + subjectId + "/pcert/" + pcertId + "/print_xls", {responseType: "blob"})).data
    }

    public async getSignedPrint(subjectId: number, pcertId: number): Promise<Blob>
    {
        return (await this.http.get("/pcert-api/api/v1/farm/" + subjectId + "/pcert/" + pcertId + "/print", {responseType: "blob"})).data
    }

    public async getIntermediarySignedPrint(pcertId: number): Promise<Blob>
    {
        return (await this.http.get("/pcert-api/api/v1/intermediary/pcert/" + pcertId + "/print", {responseType: "blob"})).data
    }
}
